import React, { useRef, useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/pro-light-svg-icons'
import { SideMenuContext } from '../../contexts/sideMenuContext'
import styles from './styles.module.css'

const SideMenuMobile = ({ tabIndex }) => {
  const { toggleMenu } = useContext(SideMenuContext)
  const sidemenuHamburgerRef = useRef()

  function handleChatKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      toggleMenu()
    }
  }
  return (
    <>
      <hot-menu-item
        slot="button"
        class={styles.sideMenuMobile}
        onKeyDown={handleChatKeydown}
        onClick={toggleMenu}
        tabIndex={tabIndex}
        ref={sidemenuHamburgerRef}
      >
        <div className="hot-application-menu__icon">
          <FontAwesomeIcon icon={faBars} />
        </div>
      </hot-menu-item>
    </>
  )
}

export default React.memo(SideMenuMobile)